import Login from "./pages/login/Login";
import React from 'react';
import Register from "./pages/register/Register";
import Information from "./pages/information/Information";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import LeftBar from "./components/leftBar/LeftBar";
import RightBar from "./components/rightBar/RightBar";
import Footer from "./components/footer/Footer";
import Home from "./pages/home/Home";
import Search from "./pages/search/Search";
import Profile from "./pages/profile/Profile";
import Login2 from "./pages/login/Login2";
import Register2 from "./pages/register/Register2";
import Organizations from "./pages/organizations/Organizations";
import "./style.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/authContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import 'bootstrap/dist/css/bootstrap.min.css';
import Forum from "./pages/forum/Forum";
import Replies from "./pages/replies/Replies";
import Organization from "./pages/organization/Organization";
import Control from "./pages/control/Control";
import Home2 from "./pages/home/Home2";
import ChatBotComponent from "./components/chatBot/ChatBotComponent";
import About from "./pages/about/About";

function App() {
  const { currentUser } = useContext(AuthContext);


  const { darkMode } = useContext(DarkModeContext);

  const queryClient = new QueryClient();

  const Layout = () => {
    return (
      <QueryClientProvider client={queryClient}>
        <div className={`theme-${darkMode ? "dark" : "light"}`} style={{marginLeft:'5%',marginRight:'5%'}}>
          <Navbar />
          <div style={{ display: "flex" }}>
            <LeftBar />
            <div style={{ flex: 6 }}>
              <Outlet />
            </div>
            {/* <RightBar /> */}
          </div>
          <Footer/>
        </div>
      </QueryClientProvider>
    );
  };
  const Layout2 = () => {
    return (
      <QueryClientProvider client={queryClient}>
        <div className={`theme-${darkMode ? "dark" : "light"}`}  style={{marginLeft:'5%',marginRight:'5%'}}>
          <Navbar />
          <div style={{ display: "flex" }}>
            
            <div style={{ flex: 6 }}>
              <Outlet />
            </div>
            <ChatBotComponent /> 
          </div>
          <Footer/>
        </div>
      </QueryClientProvider>
    );
  };
  // const ProtectedRoute = ({ children }) => {
  //   if (!currentUser) {
  //     return <Navigate to="/login" />;
  //   }

  //   return children;
  // };

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
      
          <Layout2 />
     
      ),
      children: [
        {
          path: "/",
          element: <Home2 />,
        },
        {
          path: "/profile/:id",
          element: <Profile />,
        },
        {
          path: "/search",
          element: <Search />,
        },
        {
          path: "/control",
          element: <Control />,
        },
        {
          path: "/information",
          element: <Information />,
        },
        {
          path: "/about",
          element: <About />,
        },
        {
          path: "/organizations",
          element: <Organizations />,
        },
        {
          path: "/organization/:id",
          element: <Organization />,
        },
        {
          path: "/forum",
          element: <Forum />,
        },
        {
          path: "/:id/replies",
          element: <Replies />,
        }
      ],
    },
    {
      path: "/login",
      element: <Login2 />,
    },
    {
      path: "/register",
      element: <Register2 />,
    },
    {
      path: "/home",
      element: (
      
          <Layout2 />
     
      ),
      children: [
        {
          path: "/home",
          element: <Home2 />,
        }
      ]
    }
  ]);

  return (
 
    <div>
      <RouterProvider router={router} />
    </div>
 
  );
}

export default App;
